export const formatQuestionData = (q) => ({
  id: q.qa_id,
  title: q.question,
  title_en: q.question_en,
  intro: q.brief_answer,
  intro_en: q.brief_answer_en,
  category: q.industry,
  answer: q.answer,
  answer_en: q.answer_en,
});